import axios from 'axios';

import cfac22 from '../../cfac22';

export default function ApplydiscountCoupon(uId, leadId, discountCoupon) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      post(

        `${cfac22('API_HOST_V2')}/checkout/coupon/apply`,
        {
          leadId,
          discountCoupon
        },
        {
          headers: { 'Full-Url': window.location.href }, withCredentials: true
        }
      ).
      then(async (result) => {
        // console.log("RESULT_CreateLead: ", result);
        resolve(result.data);
      }).
      catch((error) => {
        //console.log("ERROR_CreateLead: ", error);
        reject(error.response.data);
      });
    }).
    catch((error) => {
      //console.log("ERROR_TOKEN:", error);
      reject(error);
    });
  });
}
